import React from 'react';
import logo from '../assets/LOGO.png';
import logoWhite from '../assets/LOGO-white.png';

/**
 * Logo — the ServPatch mark plus wordmark, in one place.
 *
 * The wordmark is always the deep brand blue (#0B3F8F) on light surfaces and
 * white on dark ones, so it can never drift per-screen. The mark itself swaps
 * to the white-stroke variant in dark mode (the navy mark disappears against
 * the dark sidebar); both are rendered and toggled with `dark:` classes rather
 * than read from context, so this stays a dumb presentational component.
 *
 *   <Logo />                     // mark + wordmark, default size
 *   <Logo size="sm" />           // sidebar
 *   <Logo showText={false} />    // collapsed sidebar
 */

export const BRAND_BLUE = '#0B3F8F';

const SIZES = {
  sm: { img: 'w-[44px] h-[44px]', text: 'text-[23px]' },
  md: { img: 'w-11 h-11', text: 'text-[26px]' },
  lg: { img: 'w-12 h-12', text: 'text-3xl' },
};

const Logo = ({
  size = 'lg',
  showText = true,
  className = '',
  imgClassName = '',
  textClassName = '',
}) => {
  const s = SIZES[size] || SIZES.lg;
  const imgCls = `${s.img} object-contain flex-shrink-0 ${imgClassName}`;

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img src={logo} alt="ServPatch Logo" className={`${imgCls} dark:hidden`} />
      <img src={logoWhite} alt="" aria-hidden="true" className={`${imgCls} hidden dark:block`} />
      {showText && (
        <h1 className={`font-bold ${s.text} text-[#0B3F8F] dark:text-white tracking-tight whitespace-nowrap ${textClassName}`}>
          ServPatch
        </h1>
      )}
    </div>
  );
};

export default Logo;
